export type ServiceItem = {
  slug: string
  label: string
  description: string
  /** Dedicated landing page. Menus open this instead of the contact form. */
  pageHref?: string
}

/** Professional services offered under Contact → บริการของเรา */
export const OUR_SERVICES: ServiceItem[] = [
  {
    slug: "it-outsource",
    label: "IT Outsource Service",
    description: "ดูแลระบบไอทีและเครือข่ายแบบรายเดือนหรือตามโปรเจกต์",
  },
  {
    slug: "server-install",
    label: "รับติดตั้งระบบ Server",
    description: "ติดตั้ง ตั้งค่า และทดสอบเซิร์ฟเวอร์ให้พร้อมใช้งาน",
  },
  {
    slug: "private-cloud",
    label: "รับวางระบบ Private Cloud และร้านค้าส่วนตัว",
    description:
      "ร้านค้าออนไลน์บนเซิร์ฟเวอร์ขององค์กร ไม่เสียค่า GP และเป็นเจ้าของข้อมูลลูกค้า",
    pageHref: "/services/private-cloud",
  },
  {
    slug: "firewall-security",
    label: "ติดตั้งระบบ Firewall Security",
    description: "วางระบบไฟร์วอลล์และนโยบายความปลอดภัยเครือข่าย",
  },
  {
    slug: "lan-cabling",
    label: "บริการเดินสายแลน",
    description: "ออกแบบและเดินสาย LAN / structured cabling ตามผังหน้างาน",
  },
  {
    slug: "network-design-install",
    label: "บริการออกแบบและติดตั้งอุปกรณ์เน็ตเวิร์ก",
    description: "ออกแบบโครงข่ายและติดตั้งเราเตอร์ สวิตช์ Wi‑Fi ตามงาน",
  },
  {
    slug: "vpn-design-install",
    label: "บริการออกแบบและติดตั้ง VPN",
    description: "เชื่อมสาขาหรือทำงานระยะไกลผ่าน VPN อย่างปลอดภัย",
    pageHref: "/services/vpn",
  },
  {
    slug: "voip-install",
    label: "บริการติดตั้ง ซ่อม และตั้งค่าระบบ VoIP",
    description:
      "วางตู้สาขา ตั้งค่าโทรศัพท์ เสียงตามสาย PA และซ่อมระบบโทรภายใน",
    pageHref: "/services/voip",
  },
  {
    slug: "hotspot-guest-wifi",
    label: "รับวางระบบ Hotspot และ Guest Wi-Fi",
    description:
      "วาง ซ่อม และตั้งค่า Hotspot, Captive Portal และ Wi-Fi ผู้มาติดต่อ",
    pageHref: "/services/hotspot",
  },
  {
    slug: "ai-plugin-website",
    label: "รับทำ AI Plugin เสริมเว็บไซต์เดิม",
    description:
      "ใส่ผู้ช่วย AI บนเว็บที่ลูกค้าใช้อยู่แล้ว ให้ตอบจากข้อมูลร้านและส่งต่อทีมหรือ LINE",
    pageHref: "/services/ai-plugin",
  },
]

export function getServiceBySlug(slug: string): ServiceItem | undefined {
  return OUR_SERVICES.find((service) => service.slug === slug)
}

export function serviceContactHref(slug: string): string {
  return `/contact?service=${encodeURIComponent(slug)}`
}

export function serviceMenuHref(service: ServiceItem): string {
  return service.pageHref ?? serviceContactHref(service.slug)
}
